<template>
  <div class="eg">
    <div class="eg-cards">
      <article v-for="(card, index) in caseCards" :key="index" class="eg-card">
        <header class="eg-card__header">
          <span class="eg-card__icon" aria-hidden="true" />
          <h3 class="eg-card__title">{{ card.title }}</h3>
        </header>
        <ul v-if="card.items.length <= maxVisibleItems" class="eg-card__list">
          <li v-for="(item, i) in card.items" :key="i">{{ item }}</li>
        </ul>
        <div
          v-else
          class="eg-card__list eg-card__list--carousel"
          @mouseenter="pauseCarousel(index)"
          @mouseleave="resumeCarousel(index)"
        >
          <div class="eg-card__list-viewport">
            <ul
              :ref="`carouselTrack${index}`"
              class="eg-card__list-track"
              :style="getTrackStyle(index)"
              @transitionend.self="onTrackTransitionEnd(index, card, $event)"
            >
              <li
                v-for="(item, i) in getLoopItems(card.items)"
                :key="`${index}-${i}`"
              >
                {{ item }}
              </li>
            </ul>
          </div>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
const MAX_VISIBLE_ITEMS = 5;
const CAROUSEL_INTERVAL = 3000;
const CAROUSEL_DURATION = 500;
const ITEM_STEP = 40;

export default {
  name: "Eg",
  data() {
    return {
      maxVisibleItems: MAX_VISIBLE_ITEMS,
      carouselStates: [],
      carouselTimer: null,
      caseCards: [
        {
          title: "部级用户",
          items: [
            "中组部",
            "自然资源部",
            "国家统计局",
            "国家消防救援局",
            "交通运输部",
            "教育部",
          ],
        },
        {
          title: "省级用户",
          items: [
            "新疆省委组织部",
            "江苏省委组织部",
            "安徽省委组织部",
            "云南省委组织部",
            "陕西省委组织部",
            "陕西省委组织部",
            "福建省委组织部",
          ],
        },
        {
          title: "地市用户",
          items: [
            "广州市委组织部",
            "南京市委组织部",
            "滁州市委组织部",
            "贵阳市委组织部",
            "青岛市委组织部",
            "青岛市委组织部",
            "长春市委组织部",
          ],
        },
        {
          title: "国企及高校用户",
          items: [
            "南方航空",
            "招商局集团",
            "内蒙古电力",
            "江苏国金集团",
            "河南投资集团",
            "东部机场",
            "柳州城市学院",
          ],
        },
      ],
    };
  },
  created() {
    this.carouselStates = this.caseCards.map(() => ({
      scrollIndex: 0,
      animating: false,
      noTransition: false,
      paused: false,
    }));
  },
  mounted() {
    if (this.caseCards.some((card) => card.items.length > MAX_VISIBLE_ITEMS)) {
      this.startCarousel();
    }
  },
  beforeDestroy() {
    this.stopCarousel();
  },
  methods: {
    getLoopItems(items) {
      return [...items, ...items];
    },
    getTrackStyle(cardIndex) {
      const state = this.carouselStates[cardIndex];
      const translateIndex = state.scrollIndex + (state.animating ? 1 : 0);
      return {
        transform: `translate3d(0, -${translateIndex * ITEM_STEP}px, 0)`,
        transition: state.noTransition
          ? "none"
          : `transform ${CAROUSEL_DURATION}ms linear`,
      };
    },
    startCarousel() {
      this.stopCarousel();
      this.carouselTimer = window.setInterval(this.tickCarousel, CAROUSEL_INTERVAL);
    },
    stopCarousel() {
      if (this.carouselTimer) {
        window.clearInterval(this.carouselTimer);
        this.carouselTimer = null;
      }
    },
    pauseCarousel(index) {
      this.carouselStates[index].paused = true;
    },
    resumeCarousel(index) {
      this.carouselStates[index].paused = false;
    },
    tickCarousel() {
      this.caseCards.forEach((card, index) => {
        if (card.items.length <= MAX_VISIBLE_ITEMS) return;

        const state = this.carouselStates[index];
        if (state.paused || state.animating) return;

        state.animating = true;
      });
    },
    onTrackTransitionEnd(cardIndex, card, event) {
      if (event.propertyName !== "transform") return;

      const state = this.carouselStates[cardIndex];
      if (!state.animating) return;

      state.scrollIndex += 1;
      state.animating = false;

      if (state.scrollIndex >= card.items.length) {
        this.resetCarouselTrack(cardIndex, event.currentTarget);
      }
    },
    resetCarouselTrack(cardIndex, trackEl) {
      const state = this.carouselStates[cardIndex];
      const track =
        trackEl || this.$refs[`carouselTrack${cardIndex}`];

      state.noTransition = true;
      state.scrollIndex = 0;

      if (track) {
        track.style.transition = "none";
        track.style.transform = "translate3d(0, 0, 0)";
      }

      this.$nextTick(() => {
        if (track) {
          void track.offsetHeight;
        }

        requestAnimationFrame(() => {
          if (track) {
            track.style.transition = "";
            track.style.transform = "";
          }
          state.noTransition = false;
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
@item-viewport-height: 188px;

.eg {
  position: relative;
  padding: 60px 114px 70px;
  box-sizing: border-box;
}

.eg-cards {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.eg-card {
  flex: 1;
  min-width: 0;
  max-width: 410px;
  padding: 24px 28px 28px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(255, 204, 188, 1);
  box-shadow: 0 4px 16px rgba(244, 54, 8, 0.08);
  box-sizing: border-box;
}

.eg-card__header {
  display: flex;
  align-items: center;
  padding-bottom: 18px;
  margin-bottom: 16px;
  border-bottom: 1px solid rgba(255, 204, 188, 1);
}

.eg-card__icon {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  margin-right: 12px;
  background: url("@/assets/images/dh-icon.png") no-repeat center center;
  background-size: 100% 100%;
}

.eg-card__title {
  margin: 0;
  font-size: 24px;
  line-height: 1.3;
  color: rgba(106, 106, 106, 1);
}

.eg-card__list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.eg-card__list li {
  position: relative;
  padding-left: 18px;
  margin-bottom: 12px;
  font-size: 18px;
  height: 28px;
  line-height: 28px;
  color: rgba(0, 0, 0, 1);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: rgba(244, 54, 8, 1);
    transform: translateY(-50%);
  }

  &:last-child {
    margin-bottom: 0;
  }
}

.eg-card__list--carousel {
  .eg-card__list-viewport {
    height: @item-viewport-height;
    overflow: hidden;
  }

  .eg-card__list-track {
    margin: 0;
    padding: 0;
    list-style: none;
    will-change: transform;

    li {
      margin-bottom: 12px;

      &:last-child {
        margin-bottom: 12px;
      }
    }
  }
}

.eg-card__more {
  &::before {
    display: none;
  }

  padding-left: 0;
  color: rgba(106, 106, 106, 0.6);
  letter-spacing: 2px;
}
</style>
